/* @flow */

//----------------------------------------------------------------------//
// GLOBAL IMPORTS
//----------------------------------------------------------------------//

import moment from 'moment';

//----------------------------------------------------------------------//
// LOCAL IMPORTS
//----------------------------------------------------------------------//

import * as statuses from 'utils/statuses';
import Form from 'forms/_.extend';

//----------------------------------------------------------------------//
// FORM SETUP
//----------------------------------------------------------------------//

export const setupRentalAssetExtension: Function = (
  action: Object,
  notification: Object,
  handleSubmit: Function,
  onSuccess: Function,
  t: Function
) => {
  const currentEndDate: string =
    notification.template_values.review.current.end_date.rental_ends_on;

  const fields: Array<Object> = [
    {
      name: 'rentalExtension',
      label: t('general:asets.rental_rxtension'),
      fields: [
        {
          name: 'end_date',
          label: t('general:labels.new_rental_end_date'),
          rules: `required|date|after:${moment(currentEndDate).format('MMMM DD YYYY')}`,
          value: moment(action.fields.end_date).toDate(),
        },
        {
          name: 'event_parent_id',
          label: t('general:assets.labels.event_parent_id'),
          rules: 'required|string',
          value: action.fields.event_parent_id,
        },
        {
          name: 'approved',
          label: statuses.translate('approved', { t }),
          rules: 'required|boolean',
          value: action.fields.approved,
        },
      ],
    },
  ];

  const hooks: Object = {
    onSuccess(data: Object) {
      const values: Object = data.values().rentalExtension;

      handleSubmit(action, notification.template_values, values, onSuccess);
    },
  };

  return new Form(
    { fields },
    {
      hooks,
      name: 'rentalExtensionRequest',
    }
  );
};
